var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogOutIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 11.25L11.25 9M11.25 9L9 6.75M11.25 9H3M6.75 5.43644V5.40015C6.75 4.56007 6.75 4.13972 6.91349 3.81885C7.0573 3.5366 7.2866 3.3073 7.56885 3.16349C7.88972 3 8.31007 3 9.15015 3H12.6001C13.4402 3 13.8597 3 14.1805 3.16349C14.4628 3.3073 14.6929 3.5366 14.8367 3.81885C15 4.1394 15 4.55925 15 5.39768V12.6027C15 13.4411 15 13.8604 14.8367 14.1809C14.6929 14.4632 14.4628 14.6929 14.1805 14.8367C13.86 15 13.4408 15 12.6023 15H9.14768C8.30925 15 7.8894 15 7.56885 14.8367C7.2866 14.6929 7.0573 14.4629 6.91349 14.1807C6.75 13.8598 6.75 13.4401 6.75 12.6V12.5625",
    stroke: "#616161",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOutIcon);
export default __webpack_public_path__ + "static/media/logOutIcon.dc02fb2abed32c6797dd15110da3e66b.svg";
export { ForwardRef as ReactComponent };